module.exports = __webpack_public_path__ + "img/house_10.4ed0ed45.jpg";